/* Alkaline — shared behaviour for alk-* page sections: reveal on scroll, sticky chapter index, gentle image zoom. */
(function () {
  if (window.__alkBase) return;
  window.__alkBase = true;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v) { return Math.max(0, Math.min(1, v)); };
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 }) : null;

  function init(root) {
    root = root || document;
    root.querySelectorAll('.alkp .rise:not(.in)').forEach(function (el) {
      if (RM || !io || el.closest('[data-motion="off"]')) el.classList.add('in'); else io.observe(el);
    });
  }

  var zooms = [], chapters = [];
  function collect() {
    zooms = [].slice.call(document.querySelectorAll('.alkp [data-zoom]'));
    chapters = [].slice.call(document.querySelectorAll('.alkp [data-chapters]'));
  }
  function frame() {
    var h = window.innerHeight;
    if (!RM) zooms.forEach(function (img) {
      if (img.closest('[data-motion="off"]')) return;
      var r = img.parentNode.getBoundingClientRect();
      var v = clamp((h - r.top) / (h + r.height));
      img.style.transform = 'scale(' + (1.1 - 0.1 * Math.min(1, v * 1.6)) + ')';
    });
    chapters.forEach(function (nav) {
      var links = nav.querySelectorAll('a[href^="#"]'), cur = 0;
      links.forEach(function (a, i) { var t = document.getElementById(a.getAttribute('href').slice(1)); if (t && t.getBoundingClientRect().top < h * 0.35) cur = i; });
      links.forEach(function (a, i) { a.classList.toggle('on', i === cur); });
    });
  }
  var ticking = false;
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { frame(); ticking = false; }); } }, { passive: true });

  function boot() { init(); collect(); frame(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); collect(); frame(); });
})();
